module.exports = __webpack_public_path__ + "assets/img/xitong.a42d0e4d.jpg";